import { Button, Form } from 'reactstrap';
import DocumentsChecklist from './DocumentsChecklist';

interface EmploymentDocumentsFormProps {
  hireAgreementsList: any[];
  hiringAgreements: any[];
  taxDocs: any[];
  employmentEligibilityDocs: any[];
  i9Option: string;
  changeEmploymentEligibility: (e: any) => void;
  changeTaxDocs: (e: any) => void;
  handleSubmitForm: (e: any) => void;
  setHiringAgreements: (e: any) => void;
  setNewEmployeeFormStep: (e: any) => void;
  selectAllDocs: () => void;
  setI9Option: (e: any) => void;
  changeOtherDocs: (e: any) => void;
  otherDocs: any[];
}

const EmploymentDocumentsForm = ({
  hireAgreementsList,
  hiringAgreements,
  taxDocs,
  employmentEligibilityDocs,
  i9Option,
  changeEmploymentEligibility,
  changeTaxDocs,
  handleSubmitForm,
  setHiringAgreements,
  setNewEmployeeFormStep,
  selectAllDocs,
  setI9Option,
  changeOtherDocs,
  otherDocs,
}: EmploymentDocumentsFormProps) => {
  return (
    <Form onSubmit={handleSubmitForm}>
      <DocumentsChecklist
        hireAgreementsList={hireAgreementsList}
        hiringAgreements={hiringAgreements}
        taxDocs={taxDocs}
        employmentEligibilityDocs={employmentEligibilityDocs}
        otherDocs={otherDocs}
        i9Option={i9Option}
        changeEmploymentEligibility={changeEmploymentEligibility}
        changeTaxDocs={changeTaxDocs}
        changeOtherDocs={changeOtherDocs}
        setHiringAgreements={setHiringAgreements}
        setI9Option={setI9Option}
        onSelectAll={selectAllDocs}
      />

      <hr />

      <div className="d-flex justify-content-end mt-4">
        <div>
          <Button className="btn-secondary" onClick={() => setNewEmployeeFormStep(2)}>
            Back
          </Button>
          <Button color="warning" type="submit">
            Continue
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default EmploymentDocumentsForm;
